import { publicRequest, BASE_URL } from "../requestMethods";

import {
  fetchProductsStart,
  fetchProductsSuccess,
  fetchProductsFailure,
  fetchTrendingProduct,
  fetchBestSellingProduct,
  fetchCategoryProduct,
  fetchProdReviewStart,
  fetchProdReviewSuccess,
  fetchProdReviewFailure
} from "../redux/productRedux";

export const fetchProducts = async (dispatch) => {
  dispatch(fetchProductsStart());
  try {
    const res = await publicRequest.get(`${BASE_URL}products`);
    // console.log(res.data, 'for fetch prod in shop')
    dispatch(fetchProductsSuccess(res.data));
  } catch (err) {
    dispatch(fetchProductsFailure());
  }
};

export const fetchProductByCategory = async (dispatch, categoryId) => {
  console.log(categoryId, 'cat id')
  dispatch(fetchProductsStart());
  try {
    const res = await publicRequest.get(`${BASE_URL}products/findByCategory/${categoryId}`);
    console.log(res.data.data, 'data fetch from redux throught api')
    dispatch(fetchCategoryProduct(res.data.data));
  } catch (err) {
    dispatch(fetchProductsFailure());
  }
};

export const fetchTrendingProd = async (dispatch) => {
  dispatch(fetchProductsStart());
  try {
    const res = await publicRequest.get(`${BASE_URL}products/trendingProducts`);
    console.log(res.data, 'for fetch prod in shop')
    dispatch(fetchTrendingProduct(res.data.data));
  } catch (err) {
    dispatch(fetchProductsFailure());
  }
}

export const fetchBestSelllingProd = async (dispatch) => {
  dispatch(fetchProductsStart());
  try {
    const res = await publicRequest.get(`${BASE_URL}products/bestSelling`);
    console.log(res.data, 'for fetch prod in shop')
    dispatch(fetchBestSellingProduct(res.data.data));
  } catch (err) {
    dispatch(fetchProductsFailure());
  }
}



// export const fetchCategoryProd = async (dispatch, id) => {
//   dispatch(fetchProductsStart());
//   try {
//     const res = await publicRequest.get(`${BASE_URL}products/findByCategory/${id}`);
//     console.log(res.data, 'for fetch prod in shop')
//     dispatch(fetchCategoryProduct(res.data.data));
//   } catch (err) {
//     dispatch(fetchProductsFailure());
//   }
// }

export const setNewRating = async (data) => {
  console.log(data, 'data')
  return await publicRequest.post(`${BASE_URL}productReviews/newRating`, data);
}

export const fetchProdRating = async (dispatch, productId) => {
  dispatch(fetchProdReviewStart());
  try {
    const res = await publicRequest.get(`${BASE_URL}productReviews/getProdRating/${productId}`);
    console.log(res.data, 'for fetch prod in shop')
    dispatch(fetchProdReviewSuccess(res.data.data));
  } catch (err) {
    dispatch(fetchProdReviewFailure());
  }
}